import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class Quote extends BaseModel {
  static override constructorName = 'Quote'

  public author: string = ''
  public image: string | File[] = []
  public text: string = ''
  public createdAt: string = ''
  public updatedAt: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.image = toCroppedImage(data.image)
    }
  }
}
